<template>
  <div class="reset-psw-page">
    <a-card title="重置密码">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item" :title="item" />
      </a-steps>
      <div class="steps-content">
        <div v-if="current === 0">
          <a-form
            :form="passwordForm"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 16 }"
            @submit="handleSubmit"
          >
            <a-form-item label="邮箱">
              <a-input
                v-decorator="$decorator('email', '请输入邮箱')"
              ></a-input>
            </a-form-item>
            <a-form-item label="验证码">
              <a-input
                v-decorator="$decorator('captcha', '请输入验证码')"
              ></a-input>

              <a-button
                class="captcha-btn"
                type="primary"
                @click="_getCaptcha"
                :disabled="isCounting"
              >
                {{ isCounting ? `(${countdown}s)重新获取` : '获取验证码' }}
              </a-button>
            </a-form-item>
            <a-form-item label="新密码">
              <a-input-password
                v-decorator="[
                  'password',
                  {
                    rules: [
                      { required: true, message: '请输入新密码' },
                      {
                        validator: validateToNextPassword,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="确认新密码">
              <a-input-password
                v-decorator="[
                  'confirmPassword',
                  {
                    rules: [
                      { required: true, message: '请确认密码' },
                      {
                        validator: validateConfirmPassword,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item :wrapperCol="{ offset: 4 }">
              <a-button @click="goBack" class="margin-right-20">返回</a-button>
              <a-button type="primary" html-type="submit">
                下一步
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <div v-if="current === 1" class="center">
          <p class="success-info">
            <a-icon type="smile" class="margin-right-10" />
            <span>重置成功!</span>
          </p>
          <p><a-button type="primary" @click="goLogin">返回登录</a-button></p>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { ERR_OK } from '@/config'
import { getCaptcha, submitModify } from './api'

export default {
  name: 'reset-psw',
  beforeCreate() {
    this.passwordForm = this.$form.createForm(this)
  },
  data() {
    return {
      current: 0,
      steps: ['重置密码', '修改完成'],
      countdown: 60,
      isCounting: false,
      timer: null,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.passwordForm.validateFields(async (errors, values) => {
        if (errors) {
          return
        }
        const { code, message } = await submitModify(values)
        if (code === ERR_OK) {
          this.current = 1
        } else {
          this.$notification.error(message)
        }
      })
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.passwordForm
      if (value && this.confirmDirty) {
        form.validateFields(['confirmPassword'], { force: false })
      }
      callback()
    },
    validateConfirmPassword(rule, value, callback) {
      const form = this.passwordForm
      const password = form.getFieldValue('password')

      if (value && value !== password) {
        callback('两次密码不一致')
      } else {
        callback()
      }
    },
    async _getCaptcha() {
      if (this.isCounting) return
      const email = this.passwordForm.getFieldValue('email')
      if (!email || !email.trim()) {
        this.$message.error('请输入邮箱')
        return
      }
      const { code } = await getCaptcha({ email })
      if (code === ERR_OK) {
        this.isCounting = true
        this.timer = setInterval(() => {
          if (this.countdown <= 0) {
            this.timer && clearInterval(this.timer)
            this.countdown = 60
            this.isCounting = false
          } else {
            this.countdown--
          }
        }, 1000)
      }
    },
    goLogin() {
      this.$router.replace('/login')
    },
  },
  beforeDestroy() {
    // 销毁timer避免内存泄露
    this.timer && clearInterval(this.timer)
  },
}
</script>
<style lang="less" scoped>
.reset-psw-page {
  width: 70%;
  min-width: 600px;
  margin: 20px auto 0;
}
.steps-content {
  margin-top: 10px;
}
.success-info {
  font-size: 20px;
}
.center {
  text-align: center;
}
.captcha-btn {
  width: 150px;
  position: absolute;
  right: 0;
  top: -7px;
}
</style>
